module.exports = __webpack_public_path__ + "static/img/data_line_green.75b30d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/statistic/data_line_green.png
// module id = SPP9
// module chunks = 2